export default {
  fields: {
    online_shop_domain: 'Eigene Domain für den Online-Shop',
    online_shop_domain_hint:
      'Eine Domain des Restaurants, zum Beispiel bestellen.pizzeria-mario.de — nur für Bestellungen; eine Website braucht eine andere. Nach dem Speichern erscheinen hier die anzulegenden Einträge.',
    online_shop_domain_placeholder: 'bestellen.pizzeria-mario.de',
  },
};
